import { Translate } from 'next-translate';
import { User, Lot, EventRequest } from 'types';
import { generateExcelDownload } from '@utils/generateExcelDownload';
import { SUGGESTED_PRICE_ENHANCEMENT_PHASE_DEFAULT } from '@enums/flags';
import { buildExportData } from './buildExportData';

interface ExportExcelSheetParams {
  canImportPostSubmission?: boolean;
  isSampleDownload: boolean;
  lots: Lot[];
  request: EventRequest;
  setBaselineFromQuotes?: boolean;
  showDiscount: boolean;
  showLogisticsCharge: boolean;
  showPricePerUnit: boolean;
  showSuggestedPricePerUnitColumn?: boolean;
  suggestedPriceEnhancementPhase?: number;
  t: Translate,
  useSuggestedPricing?: boolean;
  user: User;
}

export const exportExcelSheet = ({
  canImportPostSubmission = false,
  isSampleDownload,
  lots,
  request,
  showPricePerUnit,
  showLogisticsCharge,
  showDiscount,
  showSuggestedPricePerUnitColumn = false,
  setBaselineFromQuotes = false,
  suggestedPriceEnhancementPhase = SUGGESTED_PRICE_ENHANCEMENT_PHASE_DEFAULT,
  t,
  user,
  useSuggestedPricing = false,
}: ExportExcelSheetParams) => {
  const { name: requestName } = request;

  const supplierVisibleOnly = Boolean(user.is_supplier);
  const data = buildExportData({
    canImportPostSubmission,
    global: user.global,
    isSupplier: supplierVisibleOnly,
    lots,
    request,
    setBaselineFromQuotes,
    showDiscount,
    showLogisticsCharge,
    showPricePerUnit,
    showSuggestedPricePerUnitColumn,
    suggestedPriceEnhancementPhase,
    t,
    useSuggestedPricing,
  });

  // TODO: handle file name limit
  const fileName = isSampleDownload ?
    t('bid_request.xlsx_download_sample_filename', { name: requestName }) :
    t('bid_request.xlsx_download_filename', { name: requestName });
  return generateExcelDownload(data, fileName);
};
